import React, {useEffect, useState, useRef} from "react";
import {createUseStyles, useTheme} from "react-jss";
import FormWithApi from "../../../../../../../../artibulles-cis/FormWithApi/FormWithApi";
import {useHistory, useLocation} from "react-router-dom";
import {toast} from "react-toastify";

import InvoiceItemsEditForm from "./InvoiceItemsEditForm";

import _ from "lodash";
const {format, parseISO} = require("date-fns");
//eslint-disable-next-line
const styles = createUseStyles((theme) => ({}));

const Component = React.memo(function Component(props) {
    const {PurchaseInvoiceID, InvoiceItemID, CloseCard, ViewEditMode} = props;

    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** CONST ******************/
    const Ref_TabNavContent = React.useRef(null);
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-bms.artibulles.com";

    const InitialCall = {type: "Edit", ID: InvoiceItemID};

    const FinalAPIUrlRelative = {
        MAIN: `${ProdURL}/api/purchaseinvoices/invoiceitems/invoiceitem`,
        DELETE: "",
        PUT: "",
        POST: "", //Call when creating a new Entry to send back the initial options if needed
    };

    //Redirect URL when Leaving the Form
    const HandleRedirection = (args) => {
        if (args.typeOfSubmit === "SaveAndQuit" || args.typeOfSubmit === "QuitNoSave") {
            CloseCard();
        }
    };
    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    /***************** FORMATTING THE DATA COMING FROM THE SERVER TO INITATE THE FORM ****************/
    const FormatDataServerToForm = (response) => {
        let data = response.data;
        let PurchaseInvoiceItem = data.PurchaseInvoiceItem;
        let PurchaseItemTypeSelectOptions = data.PurchaseItemTypeSelectOptions;

        let PurchaseItemTypeInitial = PurchaseInvoiceItem ? PurchaseInvoiceItem.TypeOfPurchase : null;
        if (PurchaseItemTypeInitial) {
            PurchaseItemTypeInitial = _.find(PurchaseItemTypeSelectOptions, {label: PurchaseItemTypeInitial}).value;
        }

        let AccountingTaxRatesOptions = [],
            ref_TaxesCodeIntial;
        if (data.AccoutingTaxesRates && Array.isArray(data.AccoutingTaxesRates)) {
            data.AccoutingTaxesRates.forEach((elem) => {
                AccountingTaxRatesOptions.push({
                    value: elem._id,
                    label: elem.TaxName,
                    Sequence: elem.Sequence,
                    VATPercentage: elem.VATPercentage,
                    TaxType: elem.TaxType,
                    TaxScope: elem.TaxScope,
                    InvoiceLabel_EN: elem.InvoiceLabel_EN,
                    InvoiceLabel_FR: elem.InvoiceLabel_FR,
                    RealPercentageInvoicePurchase: elem.RealPercentageInvoicePurchase,
                });
                if (PurchaseInvoiceItem && PurchaseInvoiceItem.ref_TaxesCode && elem._id === PurchaseInvoiceItem.ref_TaxesCode) {
                    ref_TaxesCodeIntial = elem._id;
                }
            });
        }

        let AccoutingBelgianCodes = [];

        if (data.AccoutingBelgianCodes && Array.isArray(data.AccoutingBelgianCodes)) {
            data.AccoutingBelgianCodes.forEach((elem) => {
                AccoutingBelgianCodes.push({value: elem._id, label: `${elem.AccountNumber} - ${elem.Name_FR}`});
            });
        }

        // console.log("data", data);
        //SET THE INITIAL FORM VALUES
        let CalcVATAmountInit, CalcTotalVATExcludedInit, CalcTotalVATIncludedInit;
        if (PurchaseInvoiceItem && PurchaseInvoiceItem.CalcVATAmount) {
            CalcVATAmountInit = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 2}).format(PurchaseInvoiceItem.CalcVATAmount);
        }
        if (PurchaseInvoiceItem && PurchaseInvoiceItem.CalcTotalVATExcluded) {
            CalcTotalVATExcludedInit = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 2}).format(PurchaseInvoiceItem.CalcTotalVATExcluded);
        }
        if (PurchaseInvoiceItem && PurchaseInvoiceItem.CalcTotalVATIncluded) {
            if (PurchaseInvoiceItem.Rounding === true) {
                CalcTotalVATIncludedInit = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 0}).format(PurchaseInvoiceItem.CalcTotalVATIncluded);
            } else {
                CalcTotalVATIncludedInit = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 2}).format(PurchaseInvoiceItem.CalcTotalVATIncluded);
            }
        }

        var InitialFormValues = {
            InitiaFormValues: {
                ApiID: PurchaseInvoiceItem ? PurchaseInvoiceItem._id : "new",
                ArticleName: PurchaseInvoiceItem ? PurchaseInvoiceItem.ArticleName : null,
                AccountingArticleName: PurchaseInvoiceItem ? PurchaseInvoiceItem.AccountingArticleName : null,
                SupplierRefCode: PurchaseInvoiceItem ? PurchaseInvoiceItem.SupplierRefCode : null,
                SupplierDescription: PurchaseInvoiceItem ? PurchaseInvoiceItem.SupplierDescription : null,
                InternalDescription: PurchaseInvoiceItem ? PurchaseInvoiceItem.InternalDescription : null,
                TypeOfPurchase: PurchaseItemTypeInitial,
                ref_TaxesCode: ref_TaxesCodeIntial,
                ref_AccoutingBelgianCode: PurchaseInvoiceItem ? PurchaseInvoiceItem.ref_AccoutingBelgianCode : null,
                keywords: PurchaseInvoiceItem ? PurchaseInvoiceItem.keywords : null,
                UnitPriceVATExcluded: PurchaseInvoiceItem ? PurchaseInvoiceItem.UnitPriceVATExcluded : null,
                Quantity: PurchaseInvoiceItem ? PurchaseInvoiceItem.Quantity : null,
                Currency: PurchaseInvoiceItem ? PurchaseInvoiceItem.Currency : null,
                CurrencyExchangeRate: PurchaseInvoiceItem ? PurchaseInvoiceItem.CurrencyExchangeRate : null,

                CalcVATAmount: CalcVATAmountInit,
                CalcTotalVATExcluded: CalcTotalVATExcludedInit,
                CalcTotalVATIncluded: CalcTotalVATIncludedInit,
                ExpectedDeliveryDateIso: PurchaseInvoiceItem ? PurchaseInvoiceItem.ExpectedDeliveryDateIso : null,
                Delivered: PurchaseInvoiceItem ? PurchaseInvoiceItem.Delivered : null,
                DeliveryDateIso: PurchaseInvoiceItem ? PurchaseInvoiceItem.DeliveryDateIso : null,
                ref_PurchaseInvoice: PurchaseInvoiceItem ? PurchaseInvoiceItem.ref_PurchaseInvoice : null,
                Rounding: PurchaseInvoiceItem ? PurchaseInvoiceItem.Rounding : null,
            },
            SelectOptions: {
                TypeOfPurchase: PurchaseItemTypeSelectOptions,
                ref_TaxesCode: AccountingTaxRatesOptions,
                ref_AccoutingBelgianCode: AccoutingBelgianCodes,
            },
            SubOptionsFull: {},
            // FilesUploaders: {
            //     fileuploaderName: data.tutorial.Files,
            // },
        };
        console.log("InitialFormValues Edit Item", InitialFormValues);
        return InitialFormValues;
    };
    /***************** FORMATTING THE DATA COMING FROM THE SERVER TO INITATE THE FORM ****************/

    /***************** FORMATTING THE DATA WHEN SUBMITTING THE FORM BEFORE SENDING BACK TO THE SERVER ****************/
    const FormatDataFormToServer = (FullSubmission) => {
        //USE THIS TO CHECK YOUR DATA FORMAT AND FORMATTING THE DATA CORRECTLY
        // console.log("FormatDataFormToServer", FullSubmission);
        //USE THIS TO CHECK YOUR DATA FORMAT AND FORMATTING THE DATA CORRECTLY

        if (FullSubmission) {
            //If data were sent back from the form
            let values = FullSubmission.values;

            if (values) {
                let ServerData = {
                    API_id: values.ApiID,
                    PurchaseInvoiceItem: {
                        Updatable: {
                            ref_PurchaseInvoice: PurchaseInvoiceID,
                            ArticleName: values.ArticleName,
                            AccountingArticleName: values.AccountingArticleName,
                            SupplierRefCode: values.SupplierRefCode,
                            SupplierDescription: values.SupplierDescription,
                            InternalDescription: values.InternalDescription,
                            TypeOfPurchase: values.TypeOfPurchase,
                            keywords: values.keywords,
                            UnitPriceVATExcluded: values.UnitPriceVATExcluded,
                            Quantity: values.Quantity,
                            Currency: values.Currency,
                            CurrencyExchangeRate: values.CurrencyExchangeRate,
                            ref_TaxesCode: values.ref_TaxesCode,
                            ref_AccoutingBelgianCode: values.ref_AccoutingBelgianCode,
                            Rounding: values.Rounding,
                        },
                    },
                };
                //this is what will be sent back to the server
                return ServerData;
            }
        }
    };
    /***************** FORMATTING THE DATA WHEN SUBMITTING THE FORM BEFORE SENDING BACK TO THE SERVER ****************/
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <div>
            <FormWithApi
                // WithCardModal={Id ? false : true}
                // WithCardModal={true}
                CardModalOptions={{
                    ParentCompRef: Ref_TabNavContent,
                    // CloseCard={HandleCloseCardCreate}
                    // WithPerfectScrollbar={true}
                    CardWindowPaddingVertical: "10px",
                    CardWindowPaddingHorizontal: "10px",
                    ShowCard: false,
                    WindowBackgroundColor: "rgba(0,0,0,0.3)",
                    CardBackgroundColor: "white",
                    CardBackground: "white",
                    // ClassExtendCard: classes.ClassExtendCard,
                }}
                OpenInViewMode={ViewEditMode === "View" ? true : false}
                // SwitchEditMode="FieldClick"
                toast={toast}
                // DevMode={true}
                InitialCall={InitialCall}
                // RedirectUrlOnQuit={RedirectUrlOnQuit}
                HandleRedirection={HandleRedirection}
                APIUrlRelative={FinalAPIUrlRelative}
                // APIUrlAbsolute = "null"
                FormatDataServerToForm={FormatDataServerToForm}
                FormatDataFormToServer={FormatDataFormToServer}
                FormComponent={InvoiceItemsEditForm}
                DisableToolTip={false}
                // LocaleToastMessage = en"
                // ToastDeleteConfirmation = {true}
                // ToastPublishConfirmation = {true}
                // ToastQuitWihtouSaveConfirmation = {true}
                ToastSavedMessage="Saved"
                // ToastDeletedMessage = "Delete me"
                // ToastPublishedMessage = "Publish Me"
                ButtonSaveAsDraft={{Active: false, Text: "Save draft"}}
                ButtonSaveAndQuit={{Active: true, Text: "Save And Quit"}}
                ButtonQuitNoSave={{Active: true, Text: "Exit"}}
                ButtonDelete={{Active: false, Text: "Delete"}}
                ButtonPublish={{Active: false, Text: "publier"}}
                ButtonReset={{Active: false, Text: "reseter"}}
                ButtonNext={{Active: false, Text: "Next", Save: false, FormConditions: {invalid: false, pristine: false}}}
                ButtonPrevious={{Active: false, Text: "Previous", Save: false, FormConditions: {invalid: false, pristine: false}}}
            />
        </div>
    );

    /***************** RENDER ******************/
});

export default Component;
